function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.296 23.973c.293-.055.573-.19.8-.408l11.602-11.128a.962.962 0 000-1.401l-.778-.746a1.064 1.064 0 00-1.46 0L16 20.322 5.54 10.29a1.064 1.064 0 00-1.46 0l-.777.746a.962.962 0 000 1.4l11.601 11.129a1.59 1.59 0 001.392.408z",
  fill: "currentColor"
})));